export enum ValidatorKeys {
    Required = 'required',
    MinLength = 'min-length',
    MaxLength = 'max-length',
    Min = 'min',
    Max = 'max',
    Between = 'between',
    Email = 'email',
    Compare = 'compare',
    Date = 'date',
    Phone = 'phone'
}
